import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useForm } from 'react-hook-form';
import { TextFieldWithController } from '../TextField';
import Button from '../Button';
import SpacingContainer from '../SpacingContainer';
import ValidationError from '../ValidationError';
import { getEmailValidation } from '../lib/validationRules';

const resetPasswordFormPropertyTypes = {
  emailAddressLabel: PropTypes.string.isRequired,
  requiredValidationMessage: PropTypes.string.isRequired,
  emailValidationMessage: PropTypes.string.isRequired,
  submitLabel: PropTypes.string.isRequired,
  submitHandler: PropTypes.func.isRequired,
  serverValidation: PropTypes.node,
  submitDisabled: PropTypes.bool,
};

type ResetPasswordFormProperties = InferProps<
  typeof resetPasswordFormPropertyTypes
> & {
  submitDisabled?: boolean;
};

interface ResetPasswordFormValues {
  email: string;
}

const ResetPasswordForm = ({
  emailAddressLabel,
  requiredValidationMessage,
  emailValidationMessage,
  submitLabel,
  submitHandler,
  serverValidation,
  submitDisabled,
}: ResetPasswordFormProperties) => {
  const {
    handleSubmit, errors, control,
  } = useForm<ResetPasswordFormValues>({ defaultValues: { email: '' } });

  return (
    <form
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={handleSubmit(submitHandler)}
    >
      <div className="form-item">
        <TextFieldWithController
          name="email"
          type="email"
          control={control}
          rules={
            getEmailValidation(
              emailValidationMessage,
              requiredValidationMessage,
            )
          }
          variant="filled"
          id="reset-password-email"
          label={emailAddressLabel}
        />
        <ValidationError errors={errors} name="email" />
      </div>

      <SpacingContainer />

      { serverValidation }

      <Button
        disabled={submitDisabled ?? false}
        fullWidth
        variant="contained"
        className="reset-password-submit"
        type="submit"
      >
        {submitLabel}
      </Button>
    </form>
  );
};

ResetPasswordForm.propTypes = resetPasswordFormPropertyTypes;

export default ResetPasswordForm;
